// extracted by mini-css-extract-plugin
export default {"section-container":"home_section-container__v1bL3","card-list-container":"home_card-list-container__Wv-wa"};